<template>
  <div>
    <v-row class="d-flex">
      <v-col cols="4">
        <site-filter
          siteListGetter="aiFactory/getSiteConnectors"
          itemValue="site.id"
          itemText="site.name"
          store="aiFactory"
          storeGetter="getSelectedSites"
          :multiple="false"
          :dependsOnSiteGroups="false"
        />
      </v-col>
      <v-col cols="6">
        <config-filter v-if="false" :site="site" store="newsRadar" />
      </v-col>
      <v-col cols="2" class="d-flex">
        <apply-filters :disabled="isLoading" outlined color="secondary" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { computed, onMounted, reactive } from "@vue/composition-api";
import isArray from "lodash/isArray";
import isEmpty from "lodash/isEmpty";

import useAxios from "@/hooks/useAxios";
import useProxy from "@/hooks/useProxy";

import ApplyFilters from "@/components/common/filters/ApplyFilters.vue";
import SiteFilter from "@/components/common/filters/SiteFilter";
import ConfigFilter from "@/components/news-radar/common/filters/ConfigFilter.vue";

export default {
  name: "Filters",
  components: {
    ApplyFilters,
    ConfigFilter,
    SiteFilter,
  },
  setup(props, { emit }) {
    const { store } = useProxy();
    const { isLoading } = useAxios();

    const page = reactive({
      isInitialized: false,
    });

    // =>  METHODS

    // =>  COMPUTED
    const site = computed(() => {
      const value = store.getters["aiFactory/getSelectedSites"];

      return (isArray(value) && isEmpty(value)) || value === "" ? 0 : value;
    });

    // =>  WATCH

    // =>  HOOKS
    onMounted(async () => {
      page.isInitialized = true;
    });

    // =>  DATA
    return {
      isLoading,
      site,
    };
  },
};
</script>

<style></style>
